import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PropTypes from "prop-types";

export default function IconText({
  note,
  placement,
  text,
  margin,
  icon,
  iconSize,
  color
}) {
  const tooltip = <Tooltip>{note}</Tooltip>;

  return (
    <OverlayTrigger placement={placement} overlay={tooltip}>
      <span
        className="fa-stack fa-1x"
        style={{ marginRight: margin, fontSize: "10px" }}
      >
        <i className={`fa ${icon} ${iconSize}`} style={{ color }} />
        {text && (
          <span className="fa fa-stack-1x exchange-circle-text">{text}</span>
        )}
      </span>
    </OverlayTrigger>
  );
}

IconText.defaultProps = {
  placement: "top",
  icon: "fa-circle",
  margin: "0",
  iconSize: "fa-stack-1x",
  color: "#000000"
};

IconText.propTypes = {
  placement: PropTypes.string,
  note: PropTypes.string,
  text: PropTypes.string,
  margin: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  color: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/IconText/IconText.jsx